export class ErrorModel {
  display: boolean = false;
  error: {};
}
